module.exports = __webpack_public_path__ + "static/media/sws-file.234631cf.svg";